import { gql } from "@apollo/client";

const GENERATE_TTS_AUDIO = gql`
  mutation generateTtsAudio($text: String!, $voice: String, $toneId: String) {
    generateTtsAudio(text: $text, voice: $voice, toneId: $toneId) {
      url
      key
      mimetype
      filename
      durationMs
      sizeBytes
      audioBase64
      model
      voice
      toneId
    }
  }
`;

export default GENERATE_TTS_AUDIO;
